const isExtensionAllowed = (filename: string, allowedExtensions: string) => {
  if (!allowedExtensions) {
    return false;
  }
  const allowedExtensionsList = allowedExtensions.split(',');
  return allowedExtensionsList.some((allowedExtension) => filename.endsWith(allowedExtension));
};

export default isExtensionAllowed;
